import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2025 Developed by Omer Sapir </p>
    </footer>
  );
};

export default Footer;
